module.exports = __webpack_public_path__ + "static/media/zhengshu1.9bc98429.jpg";